
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { getImagesServer } from "@/service/supplier-meta/api";
import { Upload } from "element-ui";
import { get } from "lodash";
import { BgDialog } from "@banggood/scm-fe";
interface UploadConfig {
  uploadUrl: string;
  permissionCode: string;
}
interface ElementUploadFile {
  name: string;
  percentage: number;
  raw: File;
  response: any;
  size: number;
  status: "success" | "fail";
  uid: number;
}
const uploadAvatarBus = new Vue({});
let isFetchingConfig = false;
const imgBaseUrl = "https://img.sellercube.com";
function renderFileSize(size: number): string {
  if (size >= 1024 * 1024) {
    return `${Math.round((size / (1024 * 1024)) * 100) / 100}MB`;
  } else if (size >= 1024) {
    return `${Math.round((size / 1024) * 100) / 100}KB`;
  } else {
    return `${size}B`;
  }
}
@Component({
  model: {
    prop: "value",
    event: "change",
  },
  components: {
    BgDialog,
  },
})
export default class BgAvatarUploader extends Vue {
  @Prop() value!: string;
  @Prop({ required: false }) tip?: string;
  @Prop({ required: false }) name?: string;
  @Prop({ required: false }) data?: { [x: string]: any };
  @Prop({ required: false, default: false }) editable?: boolean;
  @Prop({ required: false, default: false }) readonly?: boolean;
  @Prop({ required: false, default: null }) maxSize?: number | null;
  @Prop({ required: false, default: false }) pdfSupport?: boolean;
  @Prop({ required: false, default: false }) pdfOnly?: boolean;
  @Prop({ required: false, default: false }) pdfPreview?: boolean;
  @Prop({ required: false, default: false }) prewviewOpenNewTab?: boolean;
  @Prop({ required: false, default: false }) alertTip?: boolean;

  uploadUrl = "";
  permissionCode = "";
  imageUrl = "";
  pdfUrl = "";
  savePath = "";
  percent = 0;
  isUploadPdf = false;
  pdfPreviewDialogVisible = false;
  get accept(): string {
    if (this.pdfOnly) {
      return "application/pdf";
    }
    const acceptList = ["image/*"];
    if (this.pdfSupport) {
      acceptList.push("application/pdf");
    }
    return acceptList.join(",");
  }
  get isPdf() {
    return /\.pdf$/.test(this.imageUrl) || this.isUploadPdf;
  }
  async created(): Promise<void> {
    this.imageUrl = this.value;
    // try {
    //   const uploadConfig: UploadConfig = JSON.parse(
    //     sessionStorage.getItem("uploadConfig") || ""
    //   );
    //   console.log(uploadConfig);
    //   if (uploadConfig.uploadUrl && uploadConfig.permissionCode) {
    //     this.uploadUrl = uploadConfig.uploadUrl;
    //     this.permissionCode = uploadConfig.permissionCode;
    //   }
    // } catch (err) {
    //   console.log(err);
    // }
    if (!(this.uploadUrl && this.permissionCode)) {
      if (!isFetchingConfig) {
        isFetchingConfig = true;
        const res = await getImagesServer();
        const uploadUrl = res.result?.upload_url || "";
        const permissionCode = res.result?.perm_code || "";
        this.uploadUrl = uploadUrl;
        this.permissionCode = permissionCode;
        const data = {
          uploadUrl,
          permissionCode,
        };
        // sessionStorage.setItem("uploadConfig", JSON.stringify(data));
        uploadAvatarBus.$emit("fetchedImageUploadMess", data);
        isFetchingConfig = false;
      } else {
        uploadAvatarBus.$on("fetchedImageUploadMess", (data: UploadConfig) => {
          this.uploadUrl = data.uploadUrl;
          this.permissionCode = data.permissionCode;
        });
      }
    }
  }
  get uploaderAction(): string {
    return `${this.uploadUrl}?perm_code=${this.permissionCode}`;
  }
  get previewImgSrc(): string {
    const url = (this.imageUrl || "").trim();
    const hasHost = /^(http[s]?:)?\/\/\w+\.\w+/.test(url);
    if (url && !hasHost) {
      const beginWidthPathStr = /^\//.test(url);
      return `${imgBaseUrl}${beginWidthPathStr ? "/" : ""}${url}`;
    }
    return url;
  }
  @Watch("value")
  handleValueChange(val: string): void {
    this.imageUrl = val;
  }
  validateSize(file: ElementUploadFile): boolean {
    if (this.maxSize && file.raw.size > this.maxSize) {
      if (this.alertTip) {
        alert(`文件大小不能超过${renderFileSize(this.maxSize)}!`);
        return false;
      }
      this.$message.warning(`文件大小不能超过${renderFileSize(this.maxSize)}!`);
      return false;
    }
    return true;
  }
  handleChange(file: ElementUploadFile): void {
    console.log(file);
    this.savePath = file.name;
    let typeValid = true;
    //const validExtentions = ['jpg','png','jpeg','gif','']
    const isUploadPdf = file.raw.type.indexOf("pdf") >= 0;
    const isImage = file.raw.type.indexOf("image") >= 0;
    const uploader = this.$refs.uploader as Upload;
    if (this.pdfOnly) {
      if (!isUploadPdf) {
        this.$message.warning("请上传PDF");
        typeValid = false;
      }
    } else {
      if (!this.pdfSupport && !isImage) {
        this.$message.warning("请上传图片！");
        typeValid = false;
      } else if (this.pdfSupport && !(isImage || isUploadPdf)) {
        this.$message.warning("请上传图片/PDF！");
        typeValid = false;
      }
    }
    if (!typeValid) {
      uploader.clearFiles();
      return;
    }
    const sizeValid = this.validateSize(file);
    if (!sizeValid) {
      uploader.clearFiles();
      return;
    }
    this.isUploadPdf = isUploadPdf;
    setTimeout(() => {
      (this.$refs.uploader as Upload).submit();
    });
  }
  handleProgress(ev: any): void {
    this.percent = ev.percent;
  }
  handleSuccess(response: any): void {
    console.log(response);
    const path = get(response, "data[0].Url");
    console.log(path);
    if (path) {
      this.imageUrl = imgBaseUrl + path;
      this.$emit("change", this.imageUrl);
    }
  }
  async preview(): Promise<void> {
    const strWindowFeatures =
      "top=100,left=100,width=1000,height=500,menubar=yes,toolbar=no,location=no,resizable=yes,scrollbars=true,status=true";
    if (this.prewviewOpenNewTab && this.isPdf) {
      window.open(
        `./pdf/viewer.html?file=${this.previewImgSrc}`,
        "other",
        strWindowFeatures
      );
      return;
    }
    if (this.prewviewOpenNewTab && !this.isPdf) {
      window.open(`${this.previewImgSrc}`, "other", strWindowFeatures);
      return;
    }
    if (this.isPdf) {
      this.pdfUrl = `./pdf/viewer.html?file=${this.previewImgSrc}`;
      this.pdfPreviewDialogVisible = true;
    } else {
      const elImg = this.$refs.elImage as any;
      console.log(elImg);
      elImg.clickHandler();
    }
  }
  blobToBase64(data: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.onload = (e: any) => {
        resolve(e.target.result);
      };
      // readAsDataURL
      fileReader.readAsDataURL(data);
      fileReader.onerror = () => {
        reject(new Error("blobToBase64 error"));
      };
    });
  }
  dowloadPdf() {
    const link = document.createElement("A") as HTMLElement;
    link.setAttribute("href", this.previewImgSrc);
    link.setAttribute("download", "download");
    console.log(link);
    document.body.append(link);
    link.click();
    setTimeout(() => {
      document.body.removeChild(link);
    });
  }
  remove(): void {
    this.imageUrl = "";
    this.$emit("change", this.imageUrl);
  }
}
